import React from 'react'
import PropTypes from 'prop-types'

import { Player } from 'video-react'

import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'

import ExternalLink from '@material-ui/icons/Launch'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

require('./../../../assets/styles/video.css')

const styles = {
  cardstyle: {
    padding: 5,
  },
  figcaption: {
    padding: 5
  },
  icon: {
    fontSize: 16,
  },
};

function VideoCard(props) {
  const { classes } = props;
  return (
    <Grid container spacing={10}>
      <Grid item xs={12}>
        <Paper className={classes.cardstyle}>
          <Player>
            <source src="https://wiki.instar.com/videos/Filezilla_FTP_Server_erstellen_Aufnahmen_per_FTP_uebertragen_und_nach_X_Tagen_automatisch_löschen.mp4.mp4" />
          </Player>
          <div className={classes.figcaption}>
            <p>Dieses Video beschreibt Ihnen mehrere Punkte.</p>
            <ul>
              <li>1) Wir zeigen Ihnen wie Sie unter Windows Filezilla Server installieren, also einen eigenen FTP Server erstellen auf den die Kamera dann Ihre Aufnahmen übertragen kann.</li>
              <li>2) Wir zeigen Sie wie und wo Sie die Daten in der Kamera eintragen müssen</li>
              <li>3) Mit der automatischen Aufgabenplanung von Windows lassen wir Dateien automatisch löschen die älter als X Tage sind</li>
            </ul>
            <p>Auf <OutboundLink href="https://www.youtube.com/watch?v=xnzk7EidhxU" target="_blank" rel="noopener noreferrer">Youtube ansehen <ExternalLink className={classes.icon} /></OutboundLink></p>
          </div>
        </Paper>
      </Grid>
    </Grid>
  );
}

VideoCard.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(VideoCard)